/* eslint-disable no-useless-catch */
import { serialize } from 'utils';

import { entityService } from './services';

const pathname = '/digital-menu-shares';

export const DigitalMenuShareApi = {
  findDigitalMenuSharesByID: async (
    menuID: string,
    option: FindDigitalMenuSharesOption
  ) => {
    let url = `${pathname}/list/${menuID}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findDigitalMenuShares: async (option: FindDigitalMenuSharesOption) => {
    let url = `${pathname}/list`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findDigitalMenuSharesToShare: async (menuID: string) => {
    const url = `${pathname}/list/share/${menuID}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FindDigitalMenuSharesOption {
  page: number;
  take: number;
  reserved?: boolean;
  name?: string;
  status?: number;
}
